import React, { Fragment, useEffect, useState, useRef } from 'react';
import ServiceCenter from '../../models/ServiceCenter';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';

const EditFormPartial = (props) => {
  const { serviceCenter, setServiceCenter } = props;
  let serviceCenterObj = new ServiceCenter(serviceCenter);
  const operationalPincodesRef = useRef();
  const multiselectAddressPincodeRef = useRef();
  const commaPincodesRef = useRef();
  const [selectedDays, setSelectedDays] = useState([]);
  const [warehousesApi] = getApi('warehouses');
  const [warehouses, setWarehouses] = useState([]);
  const [branchesApi] = getApi('branches');
  const [branches, setBranches] = useState([]);
  const [pincodesApi] = getApi('pincodes');
  const [associatedPincodes, setAssociatedPincodes] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [selectedPincodes, setSelectedPincodes] = useState([]);
  const [selectedAddressPincode, setSelectedAddressPincode] = useState([]);
  const [complaintCategoriesApi] = getApi('categories');
  const [complaintCategories, setComplaintCategories] = useState([]);
  const [branchId, setBranchId] = useState([]);
  const [fetchPincodeDetailsApi] = getApi('showPincode');
  const [statesApi] = getApi('states');
  const [states, setStates] = useState([]);

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  useEffect(() => {
    fetchWarehouses();
    fetchCircles();
    fetchCategories();
    fetchApiData(statesApi, "states", { fields: 'options' }, setStates);
  }, [])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      // toast.error("Something Went Wrong !");
    }
  }

  useEffect(() => {
    if (serviceCenterObj.days) {
      const initialSelectedDays = serviceCenterObj.days.split(',');
      setSelectedDays(initialSelectedDays);
    }
  }, [serviceCenter.days]);

  useEffect(() => {
    fetchAllPincodes();
    fetchAddressPincodes();
  }, [serviceCenter.pincode])

  const fetchAllPincodes = async () => {
    try {
      const response = await pincodesApi({ fields: 'options', filters: { branch_ids: [serviceCenterObj.branch_id] } }).unwrap();
      let selected_pincodes = response.data.pincodes.filter((pincode) => serviceCenterObj.pincodes.indexOf(pincode.id) !== -1);
      setSelectedPincodes(selected_pincodes)
    } catch (error) {
    }
  }

  const fetchAddressPincodes = async () => {
    try {
      const response = await pincodesApi({ fields: 'options', filters: { branch_ids: [serviceCenterObj.branch_id] } }).unwrap();
      const selected_address_pincode = response.data.pincodes.filter((pincode) => pincode.id === serviceCenterObj.pincode);
      setSelectedAddressPincode(selected_address_pincode)
    } catch (error) {
    }
  }

  const fetchAssociatedPincodes = async (params) => {
    try {
      const response = await pincodesApi(params).unwrap();
      setAssociatedPincodes(response.data.pincodes);
    } catch (error) {
    }
  }

  const onAssociatedPincodeSearch = (value) => {
    if (value.search(/^\d{5}$/) !== -1 || value.search(/^\d{6}$/) !== -1) {
      fetchAssociatedPincodes({ search: value, filters: { branch_ids: [serviceCenterObj.branch_id] }, fields: 'options' })
    }
  }

  const fetchWarehouses = async () => {
    try {
      const response = await warehousesApi({ fields: 'options' }).unwrap();
      setWarehouses(response.data.cs_ware_houses);
    } catch (error) {
    }
  }

  const fetchCircles = async () => {
    try {
      const response = await branchesApi({ fields: 'options' }).unwrap();
      setBranches(response.data.branches);
    } catch (error) {
    }
  }

  const fetchCategories = async () => {
    try {
      const response = await complaintCategoriesApi({ fields: 'options', filters: { type: 'parent' } }).unwrap();
      setComplaintCategories(response.data.categories);
    } catch (error) {
    }
  }

  const fetchPincodeDetails = async (id) => {
    try{
      const response = await fetchPincodeDetailsApi({id : id}).unwrap();
      serviceCenterObj.city = response.data.pincode.city;
      serviceCenterObj.state = response.data.pincode.state.name;
      serviceCenterObj.state_id = states.filter(state => state.id === response.data.pincode.state.id);
      setServiceCenter(serviceCenterObj.toStateJson());
    } catch (error) {
    }
  }

  const validateValue = (field) => {
    serviceCenterObj.validate(field);
    if(field === 'latitude'){
      serviceCenterObj.validate('longitude');
    }
    if(field === 'longitude'){
      serviceCenterObj.validate('latitude');
    }
  }

  const changeValue = (field, value) => {
    serviceCenterObj[field] = value;
    validateValue(field);
    props.setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onSelectCircle = (selectedList, selectedItem) => {
    serviceCenterObj.branch_id = selectedItem.id;
    serviceCenterObj.pincode = "";
    validateValue('branch_id');
    setSelectedAddressPincode();
    setPincodes([]);
    setServiceCenter(serviceCenterObj.toStateJson());
    setBranchId(selectedItem.id);
  }

  const onRemoveCircle = (selectedList, removedItem) => {
    serviceCenterObj.branch_id = "";
    serviceCenterObj.pincodes = [];
    validateValue('branch_id');
    setServiceCenter(serviceCenterObj.toStateJson());
    operationalPincodesRef.current.resetSelectedValues();
  }

const onSelectPincodes = (selectedList, selectedItem) => {
    serviceCenterObj.pincodes.push(selectedItem.id);
    validateValue('pincodes');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onRemovePincodes = (selectedList, removedItem) => {
    serviceCenterObj.pincodes = serviceCenterObj.pincodes.filter((item) => item !== removedItem.id);
    validateValue('pincodes');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onSelectCategories = (selectedList, selectedItem) => {
    serviceCenterObj.category_ids.push({ category_id: selectedItem.id });
    validateValue('category_ids');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onRemoveCategories = (selectedList, removedItem) => {
    serviceCenterObj.category_ids = serviceCenterObj.category_ids.filter((item) => item.category_id !== removedItem.id);
    validateValue('category_ids');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onAddressPincodeSelect = (selectedList, selectedItem) => {
    serviceCenterObj.pincode = selectedItem.id;
    validateValue('pincode');
    fetchPincodeDetails(selectedItem.id);
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onAddressPincodeRemove = (selectedList, removedItem) => {
    serviceCenterObj.pincode = "";
    validateValue('pincode');
    serviceCenterObj.city = "";
    serviceCenterObj.state = "";
    serviceCenterObj.state_id = "";
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const handleDayChange = (day) => {
    const updated = toggleElement(day);
    setSelectedDays(updated);
    serviceCenterObj.days = updated.toString();
    validateValue('days');
    setServiceCenter(new ServiceCenter(serviceCenterObj));
  }

  function toggleElement(element) {
    if (selectedDays.indexOf(element) !== -1) {
      return selectedDays.filter(el => el !== element)
    } else {
      return [...selectedDays, element]
    }
  }

  const searchPincodes = async (params) => {
    try {
      const response = await pincodesApi(params).unwrap();
      setPincodes(response.data.pincodes);
    } catch (error) {
    }
  }

  function onPincodeSearch(value) {
    if (value.search(/^\d{5}$/) !== -1 || value.search(/^\d{6}$/) !== -1) {
      searchPincodes({ search: value, filters: { branch_ids: [serviceCenterObj.branch_id] }, fields: 'options' })
    }
  }

  const selectedBranch = () => {
    const foundBranch = branches.find(branch => branch.id === serviceCenterObj.branch_id);
    return foundBranch ? [foundBranch] : [];
  };

  const selectedCategories = () => {
    let filterCategories = serviceCenterObj.category_ids.map((category_obj) => category_obj.category_id)
    return complaintCategories.filter(category => filterCategories.includes(category.id));
  }

  return <Fragment>
    <div className="mb-0 col-md-6">
      <label htmlFor="service_center_type" className="form-label mb-0">Service Center Type</label>
      <select
        id="service_center_type"
        onChange={(e) => changeValue('service_center_type', e.target.value)}
        className="form-control form-control-sm font-size-12"
        value={serviceCenterObj.service_center_type}
      >
        <option disabled value="">Choose Service Center type</option>
        <option value="dsc">DSC</option>
        <option value="sf">SF</option>
      </select>
      <div id="service_center_type_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.service_center_type}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="sloc" className="form-label mb-0">SLOC</label>
      <input
        id="sloc"
        value={serviceCenterObj.sloc}
        onChange={(e) => changeValue('sloc', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        placeholder='Enter Service Location'
      />
      <div id="sloc_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.sloc}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="name" className="form-label mb-0">Name</label>
      <input
        id="name"
        value={serviceCenterObj.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        placeholder='Enter Service Center Name'
        aria-describedby='name_help'
      />
      <div id="name_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.name}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="tally_account_id" className="form-label mb-0">SAP Code</label>
      <input
        id="tally_account_id"
        value={serviceCenterObj.tally_account_id}
        onChange={(e) => changeValue('tally_account_id', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-12"
        placeholder='Enter SAP Code'
      />
      <div id="tally_account_id_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.tally_account_id}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="cs_ware_house_id" className="form-label mb-0">Warehouse</label>
      <select
        id="cs_ware_house_id"
        onChange={(e) => changeValue('cs_ware_house_id', e.target.value)}
        className="form-control form-control-sm font-size-12"
        value={serviceCenterObj.cs_ware_house_id}
      >
        <option disabled value="">Select Warehouse</option>
        {warehouses.map((warehouse) => (
          <option key={warehouse.id} value={warehouse.id}>
            {warehouse.name}
          </option>
        ))}
      </select>
      <div id="cs_ware_house_id_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.cs_ware_house_id}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="profiles" className="form-label mb-1">Is Rental Services Available</label>
      <div className="form-check mt-2">
        <input
          id="rental_services_available"
          className="form-check-input"
          type="checkbox"
          onChange={(e) => {
            serviceCenterObj.rental_services_available = e.target.checked;
            setServiceCenter(new ServiceCenter(serviceCenterObj));
          }}
          value='rental_services_available'
          checked={serviceCenterObj.rental_services_available}
        />
        <label className="form-check-label" htmlFor="rental_services_available">
          {serviceCenterObj.rental_services_available ? 'Yes' : 'No'}
        </label>
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="category_ids" className="form-label mb-0">Select Complaint Categories</label>
      <Multiselect
        id='category_ids'
        options={complaintCategories}
        selectedValues={selectedCategories()}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onSelectCategories(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveCategories(selectedList, removedItem)}
        displayValue="name"
        placeholder={'Select Categories'}
        showArrow={true}
        customArrow={true}
      />
      <div id="categories_help" className="form-text text-danger m-0">
        {serviceCenterObj.errors.category_ids}
      </div>
    </div>
    <div className="col-md-12 bg-success-subtle rounded">
      <h5 className='pt-2'>Operational Pin Codes</h5>
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="branch_id" className="form-label mb-0">Select Circle</label>
      <Multiselect
        id='branch_id'
        options={branches}
        selectedValues={selectedBranch() || branchId}
        avoidHighlightFirstOption={true}
        singleSelect={true}
        onSelect={(selectedList, selectedItem) => onSelectCircle(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveCircle(selectedList, removedItem)}
        placeholder="Select Circle"
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
        disable={true}
      />
      <div id="branch_id_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.branch_id}
      </div>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor='pincodes' className="form-label mb-0">Select PIN Codes</label>
      <Multiselect
        id='pincodes'
        options={associatedPincodes}
        selectedValues={selectedPincodes}
        onSelect={(selectedList, selectedItem) => onSelectPincodes(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemovePincodes(selectedList, removedItem)}
        onSearch={onAssociatedPincodeSearch}
        emptyRecordMsg={"Enter Correct Pincode to Search"}
        placeholder='Search Pincodes'
        displayValue='code'
        disable={serviceCenterObj.branch_id === ""}
        ref={operationalPincodesRef}
        showArrow={true}
        customArrow={true}
      />
      <div id="associated_pincodes_help" className="form-text text-danger m-0">
        {serviceCenterObj.errors.pincodes}
      </div>
    </div>
    <div className="mb-0 col-md-2 text-center align-content-center">
      <p className='h6'>
        OR
      </p>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor="ops_pincodes">Type Comma Separated Pincodes</label>
      <textarea
        id='ops_pincodes'
        value={serviceCenterObj.ops_pincodes}
        onChange={(e) => (changeValue('ops_pincodes', e.target.value))}
        ref={commaPincodesRef}
        className="form-control"
        name="ops_pincodes"
      />
    </div>

    <div className="col-md-12 bg-success-subtle rounded">
      <h5 className='pt-2'>Address</h5>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="address" className="form-label mb-0">Address</label>
      <textarea
        id="address"
        value={serviceCenterObj.address}
        onChange={(e) => changeValue('address', e.target.value)}
        type="textarea"
        className="form-control form-control-sm font-size-12"
        placeholder='Enter address'
      />
      <div id="address_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.address}
      </div>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor="latitude" className="form-label mb-0">Latitude</label>
      <input
        id="latitude"
        value={serviceCenterObj.latitude}
        onChange={(e) => changeValue('latitude', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter Latitude'
        aria-describedby='latitude_help'
      />
      <div id="latitude_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.latitude}
      </div>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor="longitude" className="form-label mb-0">Longitude</label>
      <input
        id="longitude"
        value={serviceCenterObj.longitude}
        onChange={(e) => changeValue('longitude', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter Longitude'
        aria-describedby='longitude_help'
      />
      <div id="longitude_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.longitude}
      </div>
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="pincode" className="form-label mb-0">PIN Code</label>
      <Multiselect
        id='pincode'
        options={pincodes}
        selectedValues={selectedAddressPincode}
        onSelect={(selectedList, selectedItem) => onAddressPincodeSelect(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onAddressPincodeRemove(selectedList, removedItem)}
        onSearch={onPincodeSearch}
        emptyRecordMsg={"Enter Correct Pincode to Search"}
        selectionLimit={1}
        // disable={serviceCenterObj.branch_id == ""}
        displayValue='code'
        showArrow={true}
        customArrow={true}
        disable={!serviceCenterObj.branch_id}
        ref={multiselectAddressPincodeRef}
      />
      <div id="pincode_help" className="form-text text-danger mb-0 mt-0">
        {serviceCenterObj.errors.pincode}
      </div>
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="city" className="form-label mb-0">City</label>
      <input
        id="city"
        value={serviceCenterObj.pincode ? serviceCenterObj.city : ""}
        type="text" className="form-control form-control-sm font-size-12"
        placeholder='Select pincode first.'
        disabled
        />
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="state" className="form-label mb-0">State</label>
      <input
        id="state"
        value={serviceCenterObj.pincode ? serviceCenterObj.state : ""}
        type="text"
        className="form-control form-control-sm font-size-11"
        placeholder='Select pincode first.'
        disabled
      />
    </div>
    {/* Base Error */}
    <div id= "base_error_help" className="h6 text-danger">
      {serviceCenterObj.errors.base}
    </div>

    <div className="col-md-12 bg-success-subtle rounded">
      <h5 className='pt-2'>Working hours</h5>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="start_time" className="form-label mb-2">Working Time</label>
      <div className='d-flex' id='time'>
        <div className="mb-2 col-md-3">
          <input
            id='start_time'
            type="time"
            className="form-control form-control-sm"
            value={serviceCenterObj.start_time || ''}
            onChange={(e) => (changeValue('start_time', e.target.value))}
          />
        </div>
        <div className="mb-2 col-md-2 text-center pt-2">
          To
        </div>
        <div className="mb-2 col-md-3">
          <input
            id='end_time'
            type="time"
            className="form-control form-control-sm"
            value={serviceCenterObj.end_time || ''}
            onChange={(e) => (changeValue('end_time', e.target.value))}
          />
        </div>
      </div>
      <div id="time_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.time}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="days" className="form-label mb-2">Working Days</label>
      {days.map(day => (
        <section key={day}>
          <input
            id="days"
            type="checkbox"
            onChange={() => handleDayChange(day)}
            checked={selectedDays.indexOf(day) !== -1}
            className='mt-1'
          />
          <label className='ms-2'>{day}</label>
        </section>
      ))}
      <div id="days_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.days}
      </div>
    </div>
  </Fragment>
}

export default EditFormPartial;
